module.exports = __webpack_public_path__ + "b58f9c1b814ae1013c648dc210599756.jpg";